export const FETCH_PRIORITY_TASKS = {
  START: 'START_FETCH_PRIORITY_TASKS',
  COMPLETE: 'COMPLETE_FETCH_PRIORITY_TASKS',
  FAIL: 'FAIL_FETCH_PRIORITY_TASKS',
  CLEANUP: 'CLEANUP_FETCH_PRIORITY_TASKS',
}

export const CREATE_PRIORITY_TASK = {
  START: 'START_CREATE_PRIORITY_TASK',
  COMPLETE: 'COMPLETE_CREATE_PRIORITY_TASK',
  FAIL: 'FAIL_CREATE_PRIORITY_TASK',
}

export const FETCH_PRIORITY_TASK = {
  START: 'START_FETCH_PRIORITY_TASK',
  COMPLETE: 'COMPLETE_FETCH_PRIORITY_TASK',
  FAIL: 'FAIL_FETCH_PRIORITY_TASK',
  CLEANUP: 'CLEANUP_FETCH_PRIORITY_TASK',
}

export const FETCH_PRIORITY_TASK_MENU_CURATION_TASKS = {
  START: 'START_FETCH_PRIORITY_TASK_MENU_CURATION_TASKS',
  COMPLETE: 'COMPLETE_FETCH_PRIORITY_TASK_MENU_CURATION_TASKS',
  FAIL: 'FAIL_FETCH_PRIORITY_TASK_MENU_CURATION_TASKS',
}

export const FETCH_ACTIVE_PRIORITY_TASKS = {
  START: 'START_FETCH_ACTIVE_PRIORITY_TASKS',
  COMPLETE: 'COMPLETE_FETCH_ACTIVE_PRIORITY_TASKS',
  FAIL: 'FAIL_FETCH_ACTIVE_PRIORITY_TASKS',
}

export const DELETE_PRIORITY_TASK = {
  START: 'START_DELETE_PRIORITY_TASK',
  COMPLETE: 'COMPLETE_DELETE_PRIORITY_TASK',
  FAIL: 'FAIL_DELETE_PRIORITY_TASK',
}

export const DELETE_PRIORITY_TASK_ALLOCATION = {
  START: 'START_DELETE_PRIORITY_TASK_ALLOCATION',
  COMPLETE: 'COMPLETE_DELETE_PRIORITY_TASK_ALLOCATION',
  FAIL: 'FAIL_DELETE_PRIORITY_TASK_ALLOCATION',
}

export const UPDATE_PRIORITY_TASK = {
  START: 'START_UPDATE_PRIORITY_TASK',
  COMPLETE: 'COMPLETE_UPDATE_PRIORITY_TASK',
  FAIL: 'FAIL_UPDATE_PRIORITY_TASK',
}

export const FETCH_USER_ALLOCATION_COUNTS = {
  START: 'START_FETCH_USER_ALLOCATION_COUNTS',
  COMPLETE: 'COMPLETE_FETCH_USER_ALLOCATION_COUNTS',
  FAIL: 'FAIL_FETCH_USER_ALLOCATION_COUNTS',
  CLEANUP: 'CLEANUP_FETCH_USER_ALLOCATION_COUNTS',
}

export const FETCH_PRIORITY_TASK_PROGRESS_COUNTS = {
  START: 'START_FETCH_PRIORITY_TASK_PROGRESS_COUNTS',
  COMPLETE: 'COMPLETE_FETCH_PRIORITY_TASK_PROGRESS_COUNTS',
  FAIL: 'FAIL_FETCH_PRIORITY_TASK_PROGRESS_COUNTS',
}

export const FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS = {
  START: 'START_FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS',
  COMPLETE: 'COMPLETE_FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS',
  FAIL: 'FAIL_FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS',
}

export const FETCH_BRANDS_WITH_NO_TOP_200_MENU = {
  START: 'START_FETCH_BRANDS_WITH_NO_TOP_200_MENU',
  COMPLETE: 'COMPLETE_FETCH_BRANDS_WITH_NO_TOP_200_MENU',
  FAIL: 'FAIL_FETCH_BRANDS_WITH_NO_TOP_200_MENU',
}
